Vue.component('toggle-box', {
    props: {
        id: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        }
    }
});
